<!-- 对方人员列表 -->
<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
            <salesmanAction v-if="showStatus" ref="salesmanAction" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData"></salesmanAction>
        </el-drawer>
        <salesmanSettingUnit ref="salesmanSettingUnit"></salesmanSettingUnit>
        <div class="page_content_top">

            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <vSearch @searchData="searchData" :flagList="['salesmanType']" @openSearchs="openSearch" :getRequestData=getRequestData v-if="pageShowData.jurHead" :searchList=pageShowData.jurHead.jurconfigform>
                    <template slot="searchInput" slot-scope="{formOneValue}">
                        <el-select class="form_codition" clearable size="mini" v-if="formOneValue.entityField == 'salesmanType'" @change="$forceUpdate()" v-model="getRequestData[formOneValue.entityField]"
                                   placeholder="请选择">
                            <el-option v-for="matItem in JSON.parse(formOneValue.formatterContent)" :key="matItem.key" :label="matItem.value" :value="matItem.key">
                            </el-option>
                        </el-select>
                    </template>
                </vSearch>
            </div>
        </div>
        <div class="page_content_center">
            <el-table v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini">
                <el-table-column label="选择操作" align="center" width="80">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                            <i class="el-icon-thumb"></i>
                        </el-radio>
                    </template>
                </el-table-column>
                <template v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable">
                    <el-table-column v-if="tableValye.isShow == 1" align="center" :key="tableKey" show-overflow-tooltip :min-width="tableValye.fieldWeight" :prop="tableValye.entityField" :label="tableValye.showField">
                        <template slot-scope="scope">
                            <span v-if="tableValye.fieldType == 'date'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span>
                            <span v-else-if="tableValye.entityField == 'salesSex'">
                                <el-tag size="mini" v-if="scope.row.salesSex == '男'">
                                    {{ scope.row.salesSex }}
                                </el-tag>
                                <el-tag size="mini" type="warning" v-if="scope.row.salesSex == '女'">
                                    {{ scope.row.salesSex }}
                                </el-tag>
                                <el-tag size="mini" type="info" v-if="scope.row.salesSex == '未知'">
                                    {{ scope.row.salesSex }}
                                </el-tag>
                            </span>
                            <span v-else-if="tableValye.isRift == 1">
                                <a @click="toDetail(scope.row[tableValye.riftField])">{{
                                        scope.row[tableValye.entityField] }}</a>
                            </span>
                            <el-tag size="mini" v-else-if="tableValye.entityField == 'woamState'">
                                {{ $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField]) }}</el-tag>
                            <el-tag size="mini" v-else-if="tableValye.entityField == 'terType'">
                                {{ $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField]) }}</el-tag>
                            <span v-else-if="tableValye.entityField == 'salesmanType'">
                                <el-tag size="mini" v-if="scope.row.salesmanType == 0">
                                    {{ salesType[Number(scope.row.salesmanType)] }}</el-tag>
                                <el-tag size="mini" type="warning" v-if="scope.row.salesmanType == 1">
                                    {{ salesType[Number(scope.row.salesmanType)] }}</el-tag>
                            </span>
                            <span v-else-if="tableValye.entityField == 'status'">
                                <el-tag size="mini" type="success" v-if="scope.row.status == 1">启用</el-tag>
                                <el-tag size="mini" type="error" v-if="scope.row.status == 0">停用</el-tag>
                            </span>
                            <el-tag size="mini" v-else-if="tableValye.fieldType == 'formatter'">{{
                                    $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField]) }}</el-tag>
                            <span v-else>
                                {{ scope.row[tableValye.entityField] }}
                            </span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </div>

        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>

        </div>
        <el-dialog title="状态修改" v-if="Dialog" :visible.sync="Dialog" width="300px" :modal-append-to-body='true' :append-to-body="true">
            <el-form ref="form" label-width="60px">
                <el-form-item>
                    <el-radio-group v-model="status">
                        <el-radio-button label="0">停用</el-radio-button>
                        <el-radio-button label="1">启用</el-radio-button>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="statusChange()">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
        <!-- 自定义设计 -->
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

import SearchScheme from "../../byComponents/SearchScheme.vue";
import salesmanAction from "@/components/salesmanAction.vue";
import salesmanSettingUnit from '@/components/salesmanSettingUnit.vue'

export default {
    //import引入的组件需要注入到对象中才能使用
    components: { SearchScheme, salesmanAction, salesmanSettingUnit },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            buttonList: [],
            getRequestData: {
                salesmanType: "",
                start: "",
                end: "",
                page: 1,
                rows: 30,
                osmId: "",
                unitName: "",
            },
            requesUrl: '',
            headerData: [],
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            selectedDataIndex: 0,
            selectedDetailsDataIndex: "0,0",
            detailsIndex: "",
            salesType: ["客户", "供应商", "收货", "", "提货"], //业务员类型
            geogRestData: [], //地域限制
            sexData: [], //性别
            selectedDataIndex1: 0,
            showStatus: false,
            pageShowData: [],
            formDataList: [],
            Dialog: false,
            status: 0,
            DialogVisible: false,
            parentSearchData: {},
            seId: "",
            sField: "",
            seWidth: "",
            seTitle: "",
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        async statusChange() {
            const params = {
                scsId: this.returnData.list[this.selectedDataIndex].scsId,
                status: this.status
            }
            const responseData = await this.$http.counterpartySalesmanupdateLicenceStatus(params)
            if (responseData.status == 200) {
                this.Dialog = false
                this.getDataList()
                this.$message.success(responseData.message);
            } else {
                this.$message.error(responseData.message);
            }
        },
        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path);
            let responseData = await this.$http.getJur({
                ids: [pathId.jurId]
            });
            console.log(responseData);
            if (responseData.status == 200) {
                this.pageShowData = responseData.result;
                this.formDataList = this.pageShowData.jurFormVoList;
                this.headerData = this.pageShowData.jurHead.jurconfigform;
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.getDataList();
                this.getButtonList();
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页
                var isPenetrate = true;
                // 设置缓存 存入点击单号
                this.resetSetItem("penetrateOrderId", orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({
                    //向窗口发送MessageEvent消息
                    cmd: "returnFormJson",
                    params: {
                        isPenetrate
                    }, //参数
                },
                    "*"
                );
            }
        },
        // 子组件触发
        drawerCancel(e) {
            this.showStatus = false;
            if (e == 1) this.getDataList();
        },
        getSeWidth(e) {
            console.log(e);
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            console.log(e);
            this.seTitle = e;
        },
        //检索带回数据
        changeInputModel(val) {
            console.log(val)
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val);
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.getRequestData[item] = val[item];
            });
        },
        openSearch(sId, index, type, sField) {
            this.DialogVisible = true;
            this.seId = sId;
            this.sField = sField;
            this.parentSearchData[type] = this.getRequestData[type];
        },
        //新增委托
        addLicense(id) {
            // console.log(this.returnData.list);
            // if()
            this.$refs["salesmanSettingUnit"].openBox(0, id);
        },
        //修改委托
        editLicense(data) {
            this.$refs["salesmanSettingUnit"].openBox(
                1,
                data.salesId,
                data.descibSalesplicencelinfos[this.selectedDataIndex1]
            );
        },
        // 删除数据
        delDataAction() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }

            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: [dataInfo.scsId],
                    };
                    let responseData = await this.$http.delSalesmanInfo(delData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });

                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => { });
        },
        //删除对方业务员
        // async deleteSalesMan() {
        // 	//delSalesmanInfo
        // 	let responseData = await this.$http.delSalesmanInfo({
        // 		ids: [this.returnData.list[this.selectedDataIndex].salesId],
        // 	});
        // 	if (responseData.status == 200) {
        // 		this.$message({
        // 			type: "success",
        // 			message: "删除成功!",
        // 		});
        // 		this.getDataList();
        // 	} else {
        // 		this.$message({
        // 			message: responseData.message,
        // 			type: "error",
        // 		});
        // 	}
        // },

        //判断禁用
        isDisabled(data) {
            // console.log(data);
            if (
                data.descibSalesplicencelinfo &&
                Object.keys(data.descibSalesplicencelinfo).length > 0
            ) {
                return true;
            }
            return false;
        },

        setDataIndex() {
            this.selectedDetailsDataIndex = this.selectedDataIndex + ",0";
            // this.detailsIndex = 0
        },
        imgurl() {
            // console.log(this.$store.getters.getConfig);
            this.requesUrl = this.$store.getters.getConfig.requestUrl;
        },

        // 动作集合
        actionSet(actionData) {
            switch (actionData.actionType) {
                case 0:
                    this.showStatus = true;
                    this.actionData = {
                        cate: 0,
                        formData: this.formDataList,
                        oldData: "",
                        orderId: "",
                        printSouce: "",
                        printJurId: "",
                    };
                    break;
                case 1:
                    if (this.returnData.list.length <= 0) {
                        if (!dataInfo) {
                            this.$message({
                                message: "暂无数据",
                                type: "error",
                            });
                            return false;
                        }
                    }
                    if (!this.returnData.list[this.selectedDataIndex]) {
                        this.$message({
                            message: "请先选择您要操作的数据",
                            type: "error",
                        });
                        return false;
                    }

                    var dataInfo = this.returnData.list[this.selectedDataIndex];
                    var odlData = JSON.parse(JSON.stringify(dataInfo));
                    this.showStatus = true;
                    this.actionData = {
                        cate: 1,
                        formData: this.formDataList,
                        oldData: odlData,
                        orderId: "",
                        printSouce: "",
                        printJurId: "",
                    };
                    break;
                case 2:
                    this.delDataAction()
                    break
                case 5:
                    if (this.returnData.list.length <= 0) {
                        this.$message({
                            message: "暂无数据",
                            type: "error",
                        });
                        return false;
                    }
                    if (!this.returnData.list[this.selectedDataIndex]) {
                        this.$message({
                            message: "请先选择您要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    this.status = this.returnData.list[this.selectedDataIndex].status
                    this.Dialog = true
                    break
                case 7:
                    const ormId = JSON.parse(sessionStorage.getItem('loginInfo')).ormId
                    window.location.href = this.requesUrl + '/counterpartySalesman/exportSales?ormId=' + String(ormId) + '&end=' + this.getRequestData.end
                        + '&osmId=' + this.getRequestData.osmId + '&start=' + this.getRequestData.start + '&unitName=' + this.getRequestData.unitName
                        + '&salesmanType=' + this.getRequestData.salesmanType
                        + '&page=' + this.getRequestData.page + '&rows=' + this.getRequestData.rows
                    break
                case 15:
                    this.openFormDesign()
                    break;

            }
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
// 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },

        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.getSalesmanList(this.getRequestData);
            if (responseData.status == 200) {
                // this.$set(this.returnData,'list',responseData.result.list)
                this.returnData.list = responseData.result.list;
                this.returnData.pages = responseData.result.pages;
                this.returnData.total = responseData.result.total;
                this.returnData.pageNum = responseData.result.pageNum;
                this.selectedDataIndex = 0;
                this.selectedDetailsDataIndex = "0,0";
                // this.detailsIndex = 0
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        async getPartDictionariesData() {
            let responseData = await this.$http.getPartDictionariesData({
                ids: [1, 44],
            });
            if (responseData.status == 200) {
                this.sexData = responseData.result.xb;
                this.geogRestData = responseData.result.dyxz;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPartDictionariesData();
        this.getPageInfo()
        this.imgurl()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
#mxForm .el-form-item {
    margin-bottom: 0;
}
</style>